import React, { ElementType, ReactNode, VFC, MouseEventHandler } from 'react';
import styled from 'styled-components';
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

const Wrapper = styled.div<{ color?: string; theme: Theme }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${({ color, theme }) => color || theme.palette.primary.main};
  font-size: 10px;

  ${({ theme }) => `
    ${theme.breakpoints.up('md')} {
      flex-direction: row;
      align-items: normal;
      font-size: 14px;
    }
  `}
`;
const Word = styled.p`
  margin: 0;
  word-break: keep-all;
`;

const useStyles = makeStyles((theme) => ({
  iconRoot: {
    marginRight: 0,

    [theme.breakpoints.up('md')]: {
      marginRight: theme.spacing(1),
    },
  },
}));

interface Props {
  Icon: ElementType<SvgIconProps>;
  word: ReactNode;
  color?: string;
  onClick?: MouseEventHandler;
}
const MuiIconWithWord: VFC<Props> = ({ Icon, word, color, onClick }: Props) => {
  const theme = useTheme();
  const { iconRoot } = useStyles();
  return (
    <Wrapper color={color} theme={theme} onClick={onClick}>
      <Icon classes={{ root: iconRoot }} />
      <Word>{word}</Word>
    </Wrapper>
  );
};

export default MuiIconWithWord;
